import { API, METHODS } from '../constants';
import { fetchData } from '../utils';

export const vendorBill = async ({ data = {} }) => {
  const url = API.BILLS;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const createBill = async ({ data = {} }) => {
  const url = API.CREATE_BILL;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const updateBill = async ({ data = {} }) => {
  const url = API.UPDATE_BILL;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const updateBillLine = async ({ data = {} }) => {
  const url = API.UPDATE_BILL_LINE;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const deleteBillLine = async ({ data = {} }) => {
  const url = API.DELETE_BILL_LINE;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const printBillPackingList = async ({ data = {} }) => {
  const url = API.BILL_PACKING_LIST;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
